import { render } from "./PastDiagnosisHistory.vue?vue&type=template&id=4ad8cd5c&ts=true"
import script from "./PastDiagnosisHistory.ts?vue&type=script&lang=ts&external"
export * from "./PastDiagnosisHistory.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__